<template>
  <a-modal
    :visible="visible"
    width="450px"
    title="Visualizar de solicitud"
    :keyboard="false"
    centered
    @cancel="handleClose"
    :footer="false"
  >
    <CustomScrollbar class="content" height="calc(100vh - 350px)" auto>
      <section>
        <div class="item">
          <strong>Nombre de la plantilla:</strong>
          <p>{{ template?.name }}</p>
        </div>

        <div class="item">
          <strong>Nombre de visualización:</strong>
          <p>{{ template?.display_name }}</p>
        </div>

        <div class="item">
          <strong>Idioma:</strong>
          <p>{{ template?.language }}</p>
        </div>

        <div class="item">
          <strong>Categoría:</strong>
          <p>{{ template?.category }}</p>
        </div>

        <div class="item">
          <strong>Tipo de plantilla:</strong>
          <p>{{ template?.template_type }}</p>
        </div>

        <div class="item">
          <strong>Estado de plantilla:</strong>
          <p v-if="template?.provider_state == null || template?.provider_state === WhatsappTemplateStates.Pending ">Pendiente</p>
          <p v-if="template?.provider_state === WhatsappTemplateStates.Rejected">Rechazado</p>
        </div>

        <div class="item" v-if="template?.provider_state === WhatsappTemplateStates.Rejected || template?.provider_state === WhatsappTemplateStates.Failed">
          <strong>Motivo de rechazo de plantilla:</strong>
          <p>{{ template?.reason }}</p>
        </div>

        <div class="item">
          <strong>Contenido de la plantilla:</strong>
          <p>{{ template?.template }}</p>
        </div>

        <div class="item" v-if="template?.parameters">
          <strong>Parámetros:</strong>
          <p v-for="(param, idx) in template?.parameters" :key="param.name">
            Nombre de parámetro {{ formatParamNumber(idx) }}: {{ param.name }}
          </p>
        </div>

        <div class="item">
          <strong>Botones:</strong>
          <p>{{ template?.buttons?.length ? "Con botones" : "Sin botones"}}</p>
        </div>

        <div class="item" v-if="template?.buttons?.[0]?.type">
          <strong>Tipo de botón:</strong>
          <p>{{ typeButtonsText(template?.buttons?.[0]?.type) }}</p>
        </div>

        <div class="item" v-if="template?.buttons?.[0]?.type">
          <strong>Botones configurados:</strong>
          <div v-for="(button, index) in template?.buttons" :key="button.id">
            <div class="button__name" v-if="button.type === WhatsappTemplateTypeButtons.QuickReply">
              {{ (index + 1) + ". " + button.text }}
            </div>
            <div class="button__name" v-else>
              <span class="button__name-type" v-if="button.type === WhatsappTemplateTypeSpecificButtons.PhoneNumber">
                {{ (index + 1) + ". Llamada: " }} 
              </span>
              <span class="button__name-type" v-if="button.type === WhatsappTemplateTypeSpecificButtons.VoiceCall">
                {{ (index + 1) + ". Llamada: " }} 
              </span>
              <span class="button__name-type" v-if="button.type === WhatsappTemplateTypeSpecificButtons.Url">
                {{ (index + 1) + ". URL: " }} 
              </span><br/>
              <div class="button__detail">
                <span v-if="button.type === WhatsappTemplateTypeSpecificButtons.PhoneNumber">
                  Salida de llamada: Número externo<br/>
                </span>
                <span v-if="button.type === WhatsappTemplateTypeSpecificButtons.VoiceCall">
                  Salida de llamada: WhatsApp Voice ({{ associate }})<br/>
                </span>
                <span>Texto: {{ button.text }}</span><br/>
                <a :href="button.url" target="_blank" rel="url-button" 
                  v-if="button.type === WhatsappTemplateTypeSpecificButtons.Url">
                  {{ button.url }}
                </a>
                <span v-if="button.type === WhatsappTemplateTypeSpecificButtons.PhoneNumber">
                Número: {{ button.code_phone }} {{ button.phone }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </CustomScrollbar>
    <div class="footer">
      <a-button @click="handleClose"> Cerrar visualización </a-button>
    </div>
  </a-modal>
</template>

<script>
import { defineComponent, computed } from "vue";
import { WhatsappTemplateStates, WhatsappTemplateTypeButtons, WhatsappTemplateTypeSpecificButtons } from "@/app/channels/utils/enums";
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";

export default defineComponent({
  props: {
    visible: {
      required: true,
      type: Boolean,
      default: false,
    },
    template: {
      required: true,
      type: Object,
    },
  },
  components: {
    CustomScrollbar,
  },
  setup(props, { emit }) {
    const handleClose = () => emit("close");

    const formatParamNumber = (idx) => `{{${idx + 1}}}`;

    const typeButtonsText = (type) => {
      if (type == WhatsappTemplateTypeButtons.QuickReply) {
        return 'Respuesta rápida';
      } else {
        return 'Llamada a la acción';
      }
    };

    const associate = computed(() => 
      props?.template?.channel_customer?.associate
    );

    return { WhatsappTemplateStates, WhatsappTemplateTypeButtons, WhatsappTemplateTypeSpecificButtons, handleClose, formatParamNumber, typeButtonsText, associate };
  },
});
</script>

<style lang="sass" scoped>
section
  color: $gray-8

.content
  padding: 15px 0
  margin-bottom: 40px
p
  margin: 0

.item
  margin-bottom: 16px
.button
  &__name
    margin-bottom: 7px
    &-type
      font-weight: 500
  &__detail
    margin-left: 13px

.footer
  display: flex
  align-items: center
  justify-content: center
  padding: 12px 16px
  border-top: 1px solid #e8e8e8
  position: absolute
  width: 100%
  bottom: 0
  left: 0
</style>
